/*
export const someMutation = (state) => {}
 */
export var SET_COMMONDATA = function SET_COMMONDATA(state, data) {
  state.data = data;
};
export var CLEAR_COMMONDATA = function CLEAR_COMMONDATA(state) {
  state.data = {};
};